export function TypingIndicator() {
  return (
    <div className="flex items-center gap-1 px-1 py-2">
      <span className="size-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:0ms]" />
      <span className="size-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:150ms]" />
      <span className="size-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:300ms]" />
    </div>
  )
}
